import { useEffect } from 'react';
import { useTolgee } from '@tolgee/react';
import { resolveHtmlLang } from '@agentselly/immodossier-shared';

/**
 * Hält `<html lang>` an der Sprache, in der Tolgee den Text tatsächlich
 * rendert (WCAG 2.2 AA, 3.1.1 Language of Page).
 *
 * `index.html` kann nur einen statischen Startwert liefern. Ohne diesen Sync
 * bekommen FR/IT/EN-Nutzer einen deutschen Sprachcode auf fremdsprachigem
 * Text: Screenreader sprechen französischen Text mit deutscher Aussprache,
 * Silbentrennung und Rechtschreibprüfung greifen falsch.
 *
 * Die Sprache kommt beim Laden aus der Route (`TolgeeLanguageDetector` liest
 * `/$lang/...`). `useTolgee(['language'])` rendert zusätzlich bei jedem
 * Sprachwechsel neu, also greift der Sync auch ohne Reload.
 *
 * Für `cimode` und unbekannte Werte liefert `resolveHtmlLang` kein Ergebnis —
 * dann bleibt das Attribut unverändert statt eine falsche Sprache zu
 * behaupten.
 */
export function useHtmlLang(): void {
  const tolgee = useTolgee(['language']);
  const htmlLang = resolveHtmlLang(tolgee.getLanguage());

  useEffect(() => {
    if (!htmlLang) return;

    document.documentElement.lang = htmlLang;
  }, [htmlLang]);
}

/**
 * Mountet {@link useHtmlLang} innerhalb des `TolgeeProvider`, aber ausserhalb
 * des Routers — so greift der Sync auf jeder Route, auch auf Error- und
 * Not-Found-Seiten.
 */
export function HtmlLangSync(): null {
  useHtmlLang();

  return null;
}
